import React, { useCallback, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Webcam from "react-webcam";
import toast from "react-hot-toast";
import { TextField } from "@mui/material";
import { DateTimeFmt } from "../../../utils/DataUtils";

export const InfoEtiqueta = ({
  etiqueta
}) => {

  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant="info"
        className="mx-3"
        onClick={() => setShow(true)}
      >
        INFO
      </Button>
      <Modal
        onHide={() => setShow(false)}
        show={show}
      >
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body className="d-flex flex-grow flex-wrap">
          <div className="m't-4">
            <TextField
              className="p-2"
              disabled
              label="Lote"
              defaultValue={etiqueta.lote}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2"
              disabled
              label="Ordem Produção"
              defaultValue={etiqueta.ordem_Producao}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2"
              disabled
              label="Pedido"
              defaultValue={etiqueta.pedido}
              sx={{
                width: 'auto',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2"
              disabled
              label="Posição Pedido"
              defaultValue={etiqueta.posicao_Pedido}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
          </div>

          <div>

            <TextField
              className="p-2 "
              disabled
              label="Produto"
              defaultValue={etiqueta.pedido_Produto}
              sx={{
                width: '100%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2 "
              disabled
              label="Impresso"
              defaultValue={etiqueta.impresso === true ? "SIM" : "NÃO"}
              sx={{
                width: '25%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2 "
              disabled
              label="Data Impressão"
              defaultValue={DateTimeFmt(etiqueta.dt_Impressao)}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2 "
              disabled
              label="Logo ID"
              defaultValue={etiqueta.logoID}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
          </div>

          <div>
            <TextField
              className="p-2"
              disabled
              label="Tipo Peça"
              defaultValue={etiqueta.tipo_Peca}
              sx={{
                width: '30%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
            <TextField
              className="p-2 "
              disabled
              label="Veículo"
              defaultValue={etiqueta.veiculo}
              sx={{
                width: '100%',
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>

        </Modal.Footer>
      </Modal>
    </>
  );
};
